module.exports = __webpack_public_path__ + "static/img/SteveSmith.200cd31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SteveSmith.jpg
// module id = nINv
// module chunks = 0